import React from 'react';

const Option = ({ value, text, ...props }) => {
  return (
    <option key={value} value={value} {...props}>
      {text}
    </option>
  );
};

Option.defaultProps = {};
Option.propTypes = {};

export default Option;
